<template>
  <span class="material-icons-outlined" :style="style" v-if="type === 'material'">{{ icon }}</span>
  <span v-else-if="icon === 'IconLetter'">
    <component :is="icon" :color="color" :size="size"><slot></slot></component>
  </span>
  <span v-else>
    <component :is="iconComp" :color="color" :size="size"></component>
    <div class="containerHelp_PIcon" v-if="helpComp">
      <div v-for="key in iconsApp" :key="key" class="itemHelp_PIcon">
        <span><component :is="key" :color="color" :size="size"></component></span>
        <span>{{ key }}</span>
      </div>
    </div>
  </span>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import * as icons from "./icon";

@Component({
  components: {
    ...icons,
  },
})
export class PIcon extends Vue {
  @Prop({ required: true }) icon!: string;
  @Prop({ required: false, default: "" }) type!: string;
  @Prop({ required: false, default: "#6f6f6f" }) color!: string;
  @Prop({ required: false, default: 16 }) size!: number;
  @Prop({ required: false }) help!: boolean;

  get helpComp(): boolean {
    if (this.help) {
      return true;
    } else {
      return false;
    }
  }
  get iconsApp(): string[] {
    return Object.keys(icons);
  }
  get iconComp(): string {
    return this.icon;
  }
  get style(): string {
    return "color:" + this.color + ";font-size:" + this.size + "px;";
  }
}
export default PIcon;
</script>
<style lang="scss" scoped>
.containerHelp_PIcon {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.itemHelp_PIcon {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 0 0 20%;
  margin-top: 20px;
}
.material-icons-outlined {
  vertical-align: middle;
}
</style>
